module.exports = __webpack_public_path__ + "img/news-1.beb7c492.jpg";